import React, { useState } from 'react';
import classNames from 'classnames';
import { Modal, ModalBody } from 'reactstrap';

import { Title } from 'components/typography';
import {
  IconButton,
  PlayButtonIcon,
  LeftArrowIcon,
  LeftArrowSmIcon,
} from 'components/icons';
import LearnMore from 'components/learnMore';
import { AFEX } from 'config';

import {
  servicesSection,
  servicesVideo,
  servicesVideoCover,
  serviceVideoControl,
  servicesContent,
  learnMore,
  farmersStats,
  statsValue,
  statsSuperScript,
  statsSummary,
  statsArrow,
  servicesSectionModal,
  servicesSectionIframe,
} from './scss/ServicesSection.module.scss';

const ServicesSection = () => {
  const [isModalOpen, shouldOpenModal] = useState();
  const toggleModal = () => {
    shouldOpenModal(!isModalOpen);
  };
  return (
    <section className={servicesSection} name="ourServices">
      <div className={servicesVideo}>
        <div className={servicesVideoCover} />
        <span className={serviceVideoControl}>
          <IconButton icon={PlayButtonIcon} onClick={toggleModal} />
        </span>
      </div>
      <div className={servicesContent}>
        <div>
          <Title
            value="We are building an inclusive digitized agriculture economy. Changing the story one farmer at a time."
            size="lg"
          />
          <LearnMore
            className={learnMore}
            context="AFEX IMPACT"
            theme="regular"
            to="/updates#impact"
          />
          <div className={farmersStats}>
            <div>
              <div>
                <h3 className={statsValue}>+39,789</h3>
                <span className={statsSummary}>Small Holder Farmers</span>
              </div>
              <LeftArrowSmIcon
                className={classNames('d-lg-none', statsArrow)}
              />
              <LeftArrowIcon
                className={classNames('d-none d-lg-block', statsArrow)}
              />
              <div>
                <h3 className={statsValue}>
                  72,109<sup className={statsSuperScript}>MT</sup>
                </h3>
                <span className={statsSummary}>Volume Of Grains</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        isOpen={isModalOpen}
        toggle={toggleModal}
        size="xl"
        className={servicesSectionModal}
      >
        <ModalBody>
          <iframe
            allowFullScreen
            frameBorder="0"
            title="Afex Services Video"
            src={AFEX.SERVICES_VIDEO_URL}
            className={servicesSectionIframe}
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          />
        </ModalBody>
      </Modal>
    </section>
  );
};

export default ServicesSection;
